module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA9UlEQVR4AWOgC3ghqEskQtfwUgBM8mu/4tWCieDW8FxI76mw3is2lSeSxndVLV7waj0X1nkmoPlCSA+HDXzaJ139rmaUXZgz58KGxS/kbB+JqBzKST1v7vaCXweLhlc8Wrf0rc4HBd4TMXxwYPeD9Ny7ag5Xm/qfc6nh9MMLfu2XTPLPA7Pu3Nzz4NrxC7s3XkvOesWqgtvTfNoPpIzOH15/JzH/mZHPnfjs+0pmQEHcNgjoPuPTupaYebmp756o6ktWZZBqIeyhhNDzhln5fFTayfCgl9zqBOIB6ns+7euq5o/EjYCRQEgDwjM6LwV0sMT0oAQAx3e/mTuPrucAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IM.png
// module id = 1168
// module chunks = 0